module.exports = __webpack_public_path__ + "img/blue_038.b3b58331.png";